export default __webpack_public_path__ + "static/media/info-mapa-cpc.98434443.svg";